import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "card-title mt-0 mb-4" }
const _hoisted_3 = { class: "pb-3 pt-2" }

import MonthlyReportPreCreateStatus from "@/components/MonthyReportParts/MonthlyReportPreCreateStatus.vue";
import MonthlyReportPreCreateButtonArea from "@/components/MonthyReportParts/MonthlyReportPreCreateButtonArea.vue";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthlyReportPreCreate',
  props: {
    operationOfficeId: {},
    yearMonth: {},
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.monthlyReport.preCreate')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_row, { class: "mb-1" }, {
        default: _withCtx(() => [
          _createVNode(MonthlyReportPreCreateStatus, {
            "operation-office-id": props.operationOfficeId,
            "year-month": props.yearMonth
          }, null, 8, ["operation-office-id", "year-month"]),
          _createVNode(MonthlyReportPreCreateButtonArea, {
            "operation-office-id": props.operationOfficeId,
            "year-month": props.yearMonth,
            "show-flash": props.showFlash
          }, null, 8, ["operation-office-id", "year-month", "show-flash"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})